"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./accredited"), exports);
__exportStar(require("./get-accrediteds"), exports);
__exportStar(require("./get-accrediteds-remotely"), exports);
__exportStar(require("./delete-accredited"), exports);
__exportStar(require("./delete-accredited-remotely"), exports);
__exportStar(require("./get-accredited"), exports);
__exportStar(require("./get-accredited-remotely"), exports);
__exportStar(require("./delete-accredited"), exports);
__exportStar(require("./delete-accredited-remotely"), exports);
__exportStar(require("./register-accredited"), exports);
__exportStar(require("./register-accredited-remotely"), exports);
__exportStar(require("./get-accreditedByCnpj"), exports);
__exportStar(require("./get-accreditedByCnpj-remotely"), exports);
